import { render, staticRenderFns } from "./scheduleRulesPrompt.vue?vue&type=template&id=6fb56237&scoped=true"
import script from "./scheduleRulesPrompt.vue?vue&type=script&lang=js"
export * from "./scheduleRulesPrompt.vue?vue&type=script&lang=js"
import style0 from "./scheduleRulesPrompt.vue?vue&type=style&index=0&id=6fb56237&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb56237",
  null
  
)

export default component.exports